import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 16L7 10L13 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }));
export default SvgArrowLeft;
